module.exports = __webpack_public_path__ + "img/logistics.66ae7d96.png";